import Form from './Form'
window.Form = Form

import Alert from './Alerts'
window.Alert = Alert

import Toast from './Toast'
window.Toast = Toast

import Request from './Request'
window.Request = Request
